module.exports = ".remove-table-hover tr:hover{\r\n    background-color: unset !important;\r\n }"


//////////////////
// WEBPACK FOOTER
// ./src/app/iswmMgt/Location/locations.component.css
// module id = ./src/app/iswmMgt/Location/locations.component.css
// module chunks = main